export const WELLO_IMAGE_PREFIX_URL = 'https://cdn.welfarehello.com';

//* 이미지 CDN이 죽으면 같은 CDN의 폴백도 같이 죽는다 — 앱 번들에서 낸다
export const IMAGE_PLACEHOLDER =
  '/images/local-market/placeholder-thumbnail.png';
